"use client";

import { usePathname } from "next/navigation";
import type React from "react";
import { Header } from '@/components/shared/Header'
import { Footer } from '@/components/shared/Footer'
import { WhatsAppButton } from '@/components/shared/WhatsAppButton'
import { CONTACT_INFO } from '@/utils/constants/app'

type SelectOption = { value: string; label: string };

export function SiteFrame({ children, hasActiveJobs = false, serviceOptions }: { children: React.ReactNode; hasActiveJobs?: boolean; serviceOptions?: SelectOption[] }) {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith("/admin");

  if (isAdmin) {
    return <main>{children}</main>;
  }

  return (
    <>
  <Header hasActiveJobs={hasActiveJobs} serviceOptions={serviceOptions} />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton
        phoneNumber={CONTACT_INFO.WHATSAPP_PHONE}
        message={CONTACT_INFO.WHATSAPP_DEFAULT_MESSAGE}
      />
    </>
  );
}
